import type { GetConfidenceCheckerAdminSettingsResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { confidenceCheckerAdminKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function getSettings(): Promise<GetConfidenceCheckerAdminSettingsResponse> {
  return apiClient.url("/confidence-checker-admin/settings").get().json();
}

export function useConfidenceCheckerAdminSettings(): UseQueryResult<
  GetConfidenceCheckerAdminSettingsResponse,
  Error
> {
  return useQuery({
    queryFn: getSettings,
    queryKey: confidenceCheckerAdminKeys.settings(),
  });
}
